export type MapMarkerTone = 'default' | 'active' | 'selected';

const TOKEN_BY_TONE: Record<MapMarkerTone, string> = {
  default: '--map-marker-color-default',
  active: '--map-marker-color-active',
  selected: '--map-marker-color-selected',
};

const FALLBACK_BY_TONE: Record<MapMarkerTone, string> = {
  default: '#8EDBA9',
  active: '#00CCCC',
  selected: '#339999',
};

function markerColor(tone: MapMarkerTone): string {
  if (typeof window === 'undefined') {
    return FALLBACK_BY_TONE[tone];
  }

  const value = window.getComputedStyle(document.documentElement)
    .getPropertyValue(TOKEN_BY_TONE[tone])
    .trim();

  return value || FALLBACK_BY_TONE[tone];
}

function markerDataUri(tone: MapMarkerTone): string {
  const color = markerColor(tone);
  const opacity = tone === 'default' ? '0.9' : '1';
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="42" viewBox="0 0 36 42" fill="none">
      <g opacity="${opacity}">
        <path d="M18 40S31 29.1 31 17A13 13 0 1 0 5 17c0 12.1 13 23 13 23Z" fill="${color}" stroke="#fff" stroke-width="2.4" stroke-linejoin="round"/>
        <circle cx="18" cy="17" r="5" fill="#fff"/>
        <circle cx="18" cy="17" r="2" fill="${color}"/>
      </g>
    </svg>
  `.trim();

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export function mapMarkerOptions(tone: MapMarkerTone): Record<string, unknown> {
  return {
    iconLayout: 'default#image',
    iconImageHref: markerDataUri(tone),
    iconImageSize: [36, 42],
    iconImageOffset: [-18, -40],
  };
}
